import { render } from "./VerifikatorTable.vue?vue&type=template&id=db09fbf2&scoped=true"
import script from "./VerifikatorTable.vue?vue&type=script&lang=js"
export * from "./VerifikatorTable.vue?vue&type=script&lang=js"

import "./VerifikatorTable.vue?vue&type=style&index=0&id=db09fbf2&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db09fbf2"]])

export default __exports__